import React from 'react';
import {
  Dropdown, DropdownMenu, DropdownToggle, DropdownItem, Badge,
} from 'reactstrap';
import _ from 'lodash';
import classnames from 'classnames';
import { parseAmount, simpleFriendlyDate } from 'app/utils/parsers';
import IconButton from 'app/components/general/IconButton';

import CrossIcon from 'app/images/icons/cross.svg';
import TickIcon from 'app/images/icons/tick2.svg';
import DotsIcon from 'app/images/icons/dots-filled.svg';

interface IPaymentCollectionRowProps {
  paymentCollection: any;
  teamMember: any;
  amount: number;
  pendingTeamMembers: number;
  status: string;
  isLoading: boolean;
  updatePaymentCollection: Function;
  purchasedAt: string;
}

interface IPaymentCollectionRowState {
  dropdownOpen: boolean;
}

export default class PaymentCollectionRow extends React.Component<
  IPaymentCollectionRowProps,
  IPaymentCollectionRowState,
  > {
  static defaultProps: IPaymentCollectionRowProps = {
    paymentCollection: {},
    teamMember: {},
    amount: undefined,
    pendingTeamMembers: undefined,
    status: undefined,
    updatePaymentCollection: undefined,
    isLoading: false,
    purchasedAt: undefined,
  };

  state: IPaymentCollectionRowState = {
    dropdownOpen: false,
  }

  handleCancel = (event): void => {
    event.stopPropagation();
    if (!this.props.isLoading) {
      if (this.props.paymentCollection.status === 'pending') {
        this.props.updatePaymentCollection({
          id: this.props.paymentCollection.id,
          status: 'cancelled',
        });
      } else if (this.props.paymentCollection.status === 'cancelled') {
        this.props.updatePaymentCollection({
          id: this.props.paymentCollection.id,
          status: 'pending',
        });
      }
    }
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  renderDropdown = (): React.ReactNode => (
    <DropdownMenu positionFixed>
      {this.props.paymentCollection.status === 'pending' && <DropdownItem onClick={this.handleCancel}>Cancel request</DropdownItem> }
      {this.props.paymentCollection.status === 'cancelled' && <DropdownItem onClick={this.handleCancel}>Re-activate</DropdownItem> }
    </DropdownMenu>
  );

  render(): React.ReactNode {
    let badgeColor = 'red';
    if (this.props.status === 'collected') {
      badgeColor = 'green';
    }
    const status = this.props.status === 'pending' ? 'Unpaid' : this.props.status;
    return (
      <div className="row content-row" onClick={this.toggleDropdown}>
        <div className="col col-3">{this.props.teamMember.fullName}</div>
        <div className="col col-2">{parseAmount(this.props.amount)}</div>
        <div className="col col-3 text-capitalize">
          <Badge className="negative-margin" color={badgeColor}>
            {status}
          </Badge>
        </div>
        <div className="col col-2 col-3-sm">{this.props.status === 'collected' ? simpleFriendlyDate(this.props.purchasedAt) : ''}</div>
        <div className="col col-2 col-1-sm text-right">
          {_.includes(['cancelled', 'pending'], this.props.paymentCollection.status) && (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} direction="down" className="d-inline-block">
              <DropdownToggle
                tag="div"
                className=""
                onClick={this.toggleDropdown}
                data-toggle="dropdown"
                aria-expanded={this.state.dropdownOpen}
              >
                <IconButton
                  icon={DotsIcon}
                  id={`menu-${this.props.paymentCollection.id}`}
                  isLoading={this.props.isLoading}
                  className="btn dots-icon"
                />
              </DropdownToggle>
              {this.renderDropdown()}
            </Dropdown>
          )}
        </div>
      </div>
    );
  }
}
